import { useFilter } from "hooks/filter";
import { useState, Fragment } from "react";
import { Folder } from "types/qbank/folder";
import { SearchModelEnum } from "types/qbank/searchModel";


export default function FolderItem(props: {
    close: () => void;
    folder: Folder;
    padding: number
}) {
    const {
        folder,
        padding,
        close,
    } = props;
    const [isOpen, setIsOpen] = useState(false);
    const { searchDispatch } = useFilter();

    const toggle = () => {
        setIsOpen(!isOpen);
    };

    const selectFolder = (folder: Folder) => {
        searchDispatch({
            type: "ADD_FILTER",
            payload: {
                value: folder.id,
                text: folder.name,
                label: "Folder",
                criteria: SearchModelEnum.folderIds,
            },
        });
        close();
    };

    return (
        <Fragment key={folder.id}>
            <div
                className="menu-body-item folder-svg"
                style={{ paddingLeft: `${padding}px` }}
            >
                <div
                    className="explore"
                    onClick={() => {
                        if (folder.subFolders.length) {
                            toggle();
                        }
                    }}
                >
                    {isOpen && folder.subFolders.length ? (
                        <>
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <g clipPath="url(#clip0_542_1047)">
                                        <path
                                            d="M19.5 9L12 16.5L4.5 9"
                                            stroke="#023E58"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_542_1047">
                                            <rect width="24" height="24" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <div className="folder-svg-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <g clipPath="url(#clip0_542_1056)">
                                        <path
                                            d="M3 19.5V6C3 5.80109 3.07902 5.61032 3.21967 5.46967C3.36032 5.32902 3.55109 5.25 3.75 5.25H8.74969C8.91197 5.25 9.06987 5.30263 9.19969 5.4L11.8003 7.35C11.9301 7.44737 12.088 7.5 12.2503 7.5H18.75C18.9489 7.5 19.1397 7.57902 19.2803 7.71967C19.421 7.86032 19.5 8.05109 19.5 8.25V10.5"
                                            stroke="#023E58"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M3 19.5L5.82937 11.0128C5.87916 10.8635 5.97467 10.7336 6.10238 10.6415C6.23009 10.5495 6.38352 10.5 6.54094 10.5H21.75C21.8688 10.5 21.986 10.5282 22.0918 10.5824C22.1976 10.6365 22.289 10.715 22.3585 10.8115C22.428 10.9079 22.4736 11.0194 22.4915 11.1369C22.5094 11.2544 22.4991 11.3744 22.4616 11.4872L19.7897 19.5H3Z"
                                            stroke="#023E58"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_542_1056">
                                            <rect width="24" height="24" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                        </>
                    ) : (
                        <>
                            {folder.subFolders.length ? (
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <g clipPath="url(#clip0_542_754)">
                                            <path
                                                d="M9 4.5L16.5 12L9 19.5"
                                                stroke="#009CDF"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_542_754">
                                                <rect width="24" height="24" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                            ) : (
                                ""
                            )}
                            <div className="folder-svg-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <g clipPath="url(#clip0_542_758)">
                                        <path
                                            d="M20.3334 19.5H3.69188C3.50853 19.4995 3.33284 19.4265 3.20319 19.2968C3.07355 19.1672 3.00049 18.9915 3 18.8081V7.5H20.25C20.4489 7.5 20.6397 7.57902 20.7803 7.71967C20.921 7.86032 21 8.05109 21 8.25V18.8334C21 19.0102 20.9298 19.1798 20.8048 19.3048C20.6798 19.4298 20.5102 19.5 20.3334 19.5Z"
                                            stroke="#023E58"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M3 7.5V5.25C3 5.05109 3.07902 4.86032 3.21967 4.71967C3.36032 4.57902 3.55109 4.5 3.75 4.5H8.68969C8.88834 4.50009 9.07883 4.57899 9.21937 4.71938L12 7.5"
                                            stroke="#023E58"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_542_758">
                                            <rect width="24" height="24" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                        </>
                    )}
                </div>
                <div
                    className="folder-item-name title" onClick={() => selectFolder(folder)}>
                    {folder.name}
                </div>
            </div>
            {
                isOpen &&
                folder.subFolders.map((childFolder) => (
                    <FolderItem
                        key={childFolder.id}
                        folder={childFolder}
                        padding={padding + 15}
                        close={close}
                    />
                ))
            }
        </Fragment >
    );
}